<template>
  <div class="recap-sdd d-flex flex-column justify-center">
    <span class="resultTitle mx-auto">{{$t('mandate_generated')}}</span>
    
    <div class="result-table mt-4">
      <div v-for="item in values" :key="item.label" class="d-flex divider">
        <div class="formLabel">{{$t(item.label)}}</div>
        <div class="formValue">{{item.value}}</div>
      </div>
    </div>
    <check-box
      class="recapb2bCheckbox mt-2 pl-1 pb-2 pt-2 outlined"
      v-model="checkboxChecked"
      :label="$t('info_sdd')"
      hide-details>
    </check-box>
    <div class="d-flex justify-left">
      <div v-if="canDownload" class="pdf-maker-container clickable mt-6" @click="download">
        <div class="d-flex align-center justify-left">
          <img 
            src="@/assets/document-pdf-outline.svg"
            class="pressable"/>
          <span class="download-label ml-2">{{$t('download_your_mandate')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CheckBox from '@/components/CheckBox'
  import utils from '@/utils/utils'
  import formatMixin from '@/mixins/formatMixin'
  import downLoadHelper from '@/mixins/downloadBase64'

  export default {
    name: 'RecapSDD',
    mixins: [downLoadHelper, formatMixin],
    components: {
      CheckBox
    },
    props: {
      params: {
        type: Object,
        default: () => ({})
      },
      value: {}
    },
    created () {
      this.checkboxChecked = false
    },
    watch: {
      checkboxChecked(newValue) {
        this.$emit('input', newValue)
      }
    },
    data() {
      return {
        checkboxChecked: true,
        values: [
          { label: 'amount', value: ((this.params && this.params.mkpData && this.params.mkpData.amount) ? this.formatAmount(utils.round(this.params.mkpData.amount, 2), this.params.mkpData.currencyCode, 2) : this.params.mkpData.currencyCode) },
          { label: 'rum', value: this.params.transactionData.mndtRef },
          { label: 'iban_to_use', value: this.params.startPaymentData.iban },
          { label: 'date', value: this.$t('dateAndTime').replace('{0}', this.timevalueToNumericDate(new Date())).replace('{1}', this.timevalueToTime(new Date())) }
        ],
        fileContent: this.params.transactionData.signedFileContent
      }
    }
  }
</script>